import Deliveries from './Deliveries';

export default Deliveries;
